import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount, useSort } from "@nosto/preact"
import { useRef, useEffect } from "preact/hooks";
import { sortOptions } from "../config"
import Sidebar from "./Sidebar"


export default function Toolbar({ sidebarOpen, toggleSidebar, sortOpen, toggleSort }) {
    const { loading, query, response, pageType } = useAppState();
    const { activeSort, setSort } = useSort(sortOptions);
    const selectedFiltersCount = useSelectedFiltersCount();
    const docCount = response.products?.total ?? 0;
    const sortDropdownRef = useRef(null);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if(!sortDropdownRef.current.contains(event.target)) {
                toggleSort();
            }
        }
        if(sortOpen && sortDropdownRef.current) {
            document.addEventListener('click', handleOutsideClick);
            return () => document.removeEventListener('click', handleOutsideClick);
        }
    }, [sortOpen, sortDropdownRef])

    const handleSortChange = (event) => {
        const current = event.target?.dataset?.value;
        if(current && activeSort !== current) {
            setSort(current)
        }
    };

    return (
        <div class="ns-header-toolbar">
            <div class="ns-header-controls">
                <div
                    class="ns-prod-count"
                    data-nosto-element="totalResults"
                >
                    {docCount} Products
                </div>
                
                <div class="ns-header-toggles">
                    <div 
                        class="ns-sort-container" 
                        ref={sortDropdownRef}
                    >
                        <button 
                            id="ns-toggle-sort" 
                            type="button"
                            aria-labelledby="ns-toggle-sort"
                            aria-haspopup="listbox"
                            aria-expanded={sortOpen}
                            onClick={toggleSort}
                            tabIndex="0"
                        >
                            <span>Sort</span>
                            <svg width="13px" aria-hidden="true" focusable="false" role="presentation" class="sort-caret icon icon-caret" viewBox="0 0 10 6">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
                            </svg>
                        </button>
                        <ul class="ns-sort-dropdown"
                            aria-labelledby="ns-toggle-sort"
                            role="listbox"
                            aria-hidden={!sortOpen}
                        >
                            {sortOptions.map(option => (
                                <li
                                    role="option"
                                    aria-selected={option.id === activeSort}
                                >
                                    <div
                                        class="ns-sort-option"
                                        data-value={option.id}
                                        onClick={handleSortChange}
                                    >
                                        {option.value.name}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <button 
                        id="ns-toggle-filters-sidebar"
                        aria-controls="ns-filters-sidebar" 
                        aria-expanded={sidebarOpen} 
                        onClick={toggleSidebar}
                        tabIndex="0"
                    >
                        <span>Filters</span>
                        <svg width="14px" height="13px" viewBox="0 0 14 13" version="1.1" class="filter-icon">
                            <g id="B2---PLP-&amp;-Filter/Sort" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="PLP---Desktop---1-Col-Promo---50/50-Image" transform="translate(-1230.000000, -467.000000)" fill="#FFFFFF"><g id="Group-5-Copy-8" transform="translate(1230.000000, 467.000000)"><polygon id="Fill-1" points="5.182 10.441 13.375 10.441 13.375 8.941 5.182 8.941"></polygon><polygon id="Fill-2" points="0 3.731 8.193 3.731 8.193 2.231 0 2.231"></polygon><polygon id="Fill-3" points="9.2844 0 9.2844 2.231 9.2844 3.731 9.2844 5.963 10.7834 5.963 10.7834 3.731 13.3744 3.731 13.3744 2.231 10.7834 2.231 10.7834 0"></polygon><polygon id="Fill-4" points="2.5911 6.7086 2.5911 8.9406 0.0001 8.9406 0.0001 10.4406 2.5911 10.4406 2.5911 12.6716 4.0911 12.6716 4.0911 10.4406 4.0911 8.9406 4.0911 6.7086"></polygon></g></g></g>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    )
}
